import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/AboutSection.css';
import mountainImg from '../assets/image/mountain_village.png';
import { useTranslation } from 'react-i18next';

function AboutSection() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const domains = [
    {
      id: 1,
      title: t('aboutSection.dom1Title'),
      description: t('aboutSection.dom1Desc'),
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M22 10L12 5L2 10L12 15L22 10Z" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M6 12.5V15.5C6 15.5 8.5 17.5 12 17.5C15.5 17.5 18 15.5 18 15.5V12.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M22 10V16" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      id: 2,
      title: t('aboutSection.dom2Title'),
      description: t('aboutSection.dom2Desc'),
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 21C12 21 4 15 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 15 12 21 12 21Z" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      id: 3,
      title: t('aboutSection.dom3Title'),
      description: t('aboutSection.dom3Desc'),
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 2L15 8H21L16 12L18 18L12 14L6 18L8 12L3 8H9L12 2Z" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12 14V22" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      id: 4,
      title: t('aboutSection.dom4Title'),
      description: t('aboutSection.dom4Desc'),
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M3 21H21" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3 10L12 3L21 10V21H3V10Z" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M9 21V12H15V21" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    }
  ];

  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-layout">
          {/* Left: About Text + Image */}
          <div className="about-main">
            <div className="about-image">
              <img src={mountainImg} alt="Village d'Asni au cœur du massif du Toubkal" />
            </div>
            <div className="about-content">
              <h2 className="about-title">{t('aboutSection.title')} <span className="keyword">Tiwizi</span></h2>
              <p className="about-description">
                {t('aboutSection.desc')}
              </p>
              <button className="btn-learn-more" onClick={() => navigate('/about')}>
                {t('aboutSection.btn')}
              </button>
            </div>
          </div>

          {/* Right: Domains Grid */}
          <div className="about-domains">
            <h2 className="domains-title">{t('aboutSection.domainsTitle')}</h2>
            <div className="domains-grid">
              {domains.map((domain) => (
                <div key={domain.id} className="domain-card">
                  <div className="domain-icon">{domain.icon}</div>
                  <h3 className="domain-name">{domain.title}</h3>
                  <p className="domain-description">{domain.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
